import isBrowserContext from "helpers/isBrowserContext";
import { useEffect, useState } from "react";

export default (styles?: any, name?: string) => {
    const animationClasses: any[] = [];

    const [websiteType, setWebsiteType] = useState<string>("");

    useEffect(() => {
        if (isBrowserContext() && window?.location?.href) {
            const isRekomUrl = window.location.origin === "https://www.rekomgroup.com" || window.location.origin === "https://rekomgroup.com" || window.location.href.indexOf("http://localhost:3000/rekomgroup") >= 0 || window.location.href.indexOf("https://stage.rekom.frontend.heyday.dk/group") >= 0 || window.location.href.indexOf("https://production.rekom.frontend.heyday.dk/rekomgroup") >= 0;

            // REKOM Group
            if (isRekomUrl) {
                setWebsiteType("REKOM");
            }

            // Other
            else {
                setWebsiteType("OTHER");
            }
        }
    }, []);

    // TODO: Make this more dynamic
    if (name === "animation1" && websiteType === "REKOM" && styles) {
        animationClasses.push(styles.has_animation);
    }

    const shouldUseAnimations = (name === "animation1" && websiteType === "REKOM");
    return { animationClasses, shouldUseAnimations };
};